import React from 'react';
import {
    AppsListOfType,
    Details,
    SystemRequirements
} from './components/renderHelpers';
import AppRatings from './components/AppRatings';
import ShareLinks from './components/ShareLinks';
// import PaypalDonate from './components/PaypalDonate';
import styles from './SidePanel.module.scss'
import Card, { CardItem } from "../../../components/card/Card";

const SideBlock = ({children}) => <Card className={styles.block}>{children}</Card>;

const SideContainer = ({shouldRender, title, children}) => {
    if (shouldRender) {
        return (
            <>
                {title && <h5 className={styles.block__title}>{title}</h5>}
                <div>
                    <CardItem style={{padding: '20px 0'}}>{children}</CardItem>
                </div>
            </>
        );
    } else return null
};

export default function SidePanel({app, rating}) {

    const githubDocker = app.github?.find(i => i.type === 'github-docker');
    const stackHub = app.github?.find(i => i.type === 'stackhub');

    return (
        <React.Fragment>
            <SideBlock>
                <SideContainer title='Rating' shouldRender={true}>
                    <AppRatings rating={rating}/>
                </SideContainer>
            </SideBlock>
            <SideBlock>
                <SideContainer title='Details' shouldRender={true}>
                    <Details app={app}/>
                </SideContainer>
                <div style={{paddingTop: '10px'}}>
                    {
                        !!stackHub?.url &&
                        <CardItem>
                            <div className={styles['github']}>
                                <i className="fab fa-github fa-2x" aria-hidden="true"/>
                                <a href={stackHub?.url} target="_blank">
                                    {app['name']}
                                    <i className="fas fa-external-link-alt" aria-hidden="true"/>
                                </a>
                            </div>
                        </CardItem>

                    }
                    {
                        !!githubDocker?.url &&
                        <CardItem>
                            <div className={styles['github']}>
                                <i className="fab fa-github fa-2x" aria-hidden="true"/>
                                <i className="fab fa-docker fa-2x" aria-hidden="true"/>
                                <a
                                    href={githubDocker?.url}
                                    target="_blank"
                                >
                                    {app['name']}
                                    <i className="fas fa-external-link-alt" aria-hidden="true"/>
                                </a>
                            </div>
                        </CardItem>
                    }
                </div>
                <SideContainer title="What's included" shouldRender={!!Object.keys(app.apps || {})?.length}>
                    <AppsListOfType type='apps' app={app}/>
                </SideContainer>
                <SideContainer title='Services' shouldRender={!!Object.keys(app.services || {})?.length}>
                    <AppsListOfType type='services' app={app}/>
                </SideContainer>
                <SideContainer title='System Requirements' shouldRender={app.disk_size || app.ram_size}>
                    <SystemRequirements app={app}/>
                </SideContainer>
            </SideBlock>
            <SideBlock>
                <SideContainer title='Share' shouldRender={true}>
                    <ShareLinks/>
                </SideContainer>
            </SideBlock>
            {/*{app['commercial'] === false && <PaypalDonate/>}*/}
        </React.Fragment>
    );
}